<template>
  <div class="component-tabPage">
    <md-scroll-view :ref="`tab${tabId}_scrollView`" :scrolling-x="false" @end-reached="onPullingUp">
      <div>
        <!-- 轮播图的骨架屏 -->
        <div class="banner-skeleton" v-if="showBannerSkeleton">
          <md-skeleton :row="2"></md-skeleton>
        </div>
        <!-- 轮播图 -->
        <div
          class="banner-list"
          @touchmove="handleTouchBanner"
          @touchend="handleTouchBanner"
          :style="`height:${bannerHeight}px`"
          v-show="!showBannerSkeleton && bannerList.length > 0"
        >
          <md-swiper ref="tabSwiper" :is-prevent="false" :useNative-driver="false">
            <md-swiper-item :key="$index" v-for="(item, $index) in bannerList">
              <img class="banner-img" :src="formatHttpImg(item.slideImg)" @click="handleClickBanner(item)" />
            </md-swiper-item>
          </md-swiper>
        </div>
        <!-- 分类菜单的骨架屏 -->
        <div class="tabCate-skeleton" v-if="showCateSkeleton">
          <md-skeleton :row="2"></md-skeleton>
        </div>
        <!-- 分类菜单 -->
        <div class="cate-wrap" v-if="!showCateSkeleton && tabCateList.length > 0">
          <div class="swiper-wrap">
            <swiper class="cate-list" ref="tabCateSwiper" :options="cateSwiperOptions">
              <swiper-slide
                :class="`cate-column${tabCateList.length <= 5 ? ' swiper-no-swiping' : ''}`"
                :style="{width: `${cateColumnWidth}px` }"
                v-for="item in tabCateList"
              >
                <div
                  class="cate-item"
                  :key="menuItem.cateId"
                  v-for="menuItem in item"
                  @click="handleClickGoCateGoodsList(menuItem)"
                >
                  <img
                    v-show="menuItem.cateImg"
                    class="cate-img"
                    :src="menuItem.cateImg"
                    :style="{ width: `${cateColumnWidth * 0.68}px`, height: `${cateColumnWidth * 0.68}px` }"
                  />
                  <div class="label">{{ menuItem.cateName }}</div>
                </div>
              </swiper-slide>
              <div
                class="tabCateSwiper-scrollbar"
                slot="scrollbar"
                v-if="tabCateList.length>5"
                v-show="tabCateList.length>5 && curTabId === tabId"
              ></div>
            </swiper>
          </div>
        </div>
        <!-- 商品列表的骨架屏 -->
        <div class="goodsList-skeleton" v-if="showGoodsListSkeleton">
          <md-skeleton
            class="skeleton-item"
            v-for="item in 5"
            :key="item"
            avatar
            title
            :row="2"
            :loading="showGoodsListSkeleton"
          ></md-skeleton>
        </div>
        <!-- 首页&好货优选 -->
        <div class="choiceGoods-wrap" v-if="isHomePage && choiceGoodsInfo.cate.cateId > 0">
          <div class="choiceGoods-head" @click="handleClickGoCateGoodsList(choiceGoodsInfo.cate)">
            <img class="icon-live" :src="liveIcon" />
            <span class="more-title">{{ choiceGoodsInfo.cate.cateName }}</span>
            <div class="btn-more-goods">
              <span class="more-goods-text">更多好货</span>
              <img class="icon-into" :src="intoIcon" />
            </div>
          </div>
          <div class="choiceGoods-list">
            <SingleGoodsItem
              v-for="goodsItem in choiceGoodsInfo.data"
              :item="goodsItem"
              :channel="channel"
            />
          </div>
        </div>

        <!-- 首页&为你推荐 -->
        <div class="recommendGoods-wrap" v-if="isHomePage">
          <div class="recommendGoods-head" v-if="recommendGoodsListData.total_count > 0">
            <img class="foryou-img" :src="foryouIcon" />
          </div>
          <div class="recommendGoods-list">
            <MultiGoodsItem
              :style="{ width: `${98 / 2}%`, marginRight: `${(index + 1) % 2 === 0 ? '0' : `${2 / (2 - 1)}%`}` }"
              :key="`${goodsItem.goodsId}_${index}`"
              v-for="(goodsItem, index) in recommendGoodsListData.data"
              :item="goodsItem"
              :channel="channel"
            />
          </div>
        </div>

        <!-- 筛选组件 -->
        <FilterView
          ref="filterView"
          :channel="channel"
          @change="handleChangeSort"
          v-show="!isHomePage && !showGoodsListSkeleton && tabGoodsListData.total_count > 0"
        />
        <!-- tab分类对应的商品列表 -->
        <div class="goods-list" v-if="!isHomePage">
          <SingleGoodsItem
            v-for="goodsItem in tabGoodsListData.data"
            :item="goodsItem"
            :channel="channel"
          />
        </div>
      </div>
      <md-scroll-view-more
        slot="more"
        :is-finished="(!isLoadingGoodsList && isHomePage && !recommendGoodsListData.loadMore) || (!isHomePage && !tabGoodsListData.loadMore)"
      ></md-scroll-view-more>
    </md-scroll-view>
  </div>
</template>

<script>
import { getPageData } from '@/utils/help'
import FilterView from '@/components/filterView'
import SingleGoodsItem from '@/components/singleGoodsItem'
import MultiGoodsItem from '@/components/multiGoodsItem'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import { ScrollView, ScrollViewMore, Swiper, SwiperItem, Skeleton } from 'mand-mobile'
export default {
  name: 'tabPage',
  components: {
    swiper,
    swiperSlide,
    FilterView,
    SingleGoodsItem,
    MultiGoodsItem,
    [Skeleton.name]: Skeleton,
    [ScrollView.name]: ScrollView,
    [ScrollViewMore.name]: ScrollViewMore,
    [Swiper.name]: Swiper,
    [SwiperItem.name]: SwiperItem,
  },
  props: {
    curTabId: {
      type: Number,
      default: 0,
    },
    tabId: {
      type: Number,
      default: 0,
    },
    isHomePage: {
      type: Boolean,
      default: false,
    },
    bannerHeight: {
      type: Number,
      default: 0,
    },
    cateColumnWidth: {
      type: Number,
      default: 0,
    },
    channel: {
      type: String,
      default: 'tbk',
    },
  },
  data() {
    return {
      liveIcon: require('../assets/images/ic_home_live.png'),
      intoIcon: require('../assets/images/ic_white_into.png'),
      foryouIcon: require('../assets/images/ic_home_likeforyou.png'),
      cateSwiperOptions: {
        // 分类菜单swiper
        direction: 'horizontal',
        slidesPerView: 'auto',
        freeMode: true,
        noSwiping: true,
        scrollbar: {
          el: '.tabCateSwiper-scrollbar',
        },
      },
      isInit: false,
      scrollVM: null, // 滚动器
      offsetTop: 0, // 滚动的距离
      showBannerSkeleton: true, // 显示轮播图骨架屏
      showCateSkeleton: true, // 显示分类列表骨架屏
      showGoodsListSkeleton: true, // 显示商品列表骨架屏
      isLoadingGoodsList: false, // 正在加载商品列表
      bannerList: [],
      tabCateList: [],
      sort: '', // 排序方式
      choiceGoodsInfo: {
        // 好货优选
        cate: {
          cateId: 0,
          cateName: '',
        },
        data: [],
      },
      tabGoodsListData: {
        // tab对应的商品列表
        currentPage: 1,
        pageSize: 20,
        total_count: 0,
        loadMore: true,
        data: [],
      },
      recommendGoodsListData: {
        // 为你推荐
        currentPage: 1,
        pageSize: 20,
        total_count: 0,
        loadMore: true,
        data: [],
      },
    }
  },
  mounted() {
    this.scrollVM = this.$refs[`tab${this.tabId}_scrollView`]
  },
  activated() {
    if (this.curTabId === this.tabId) {
      this.$_setScrollPosition()
    }
  },
  deactivated() {
    if (this.curTabId === this.tabId) {
      this.offsetTop = this.scrollVM.getOffsets().top
    }
  },
  methods: {
    /**
     * 设置滚动距离
     */
    $_setScrollPosition() {
      this.scrollVM.reflowScroller()
      this.$nextTick(() => {
        if (this.offsetTop > 0) {
          this.scrollVM.scrollTo(0, this.offsetTop, false)
        }
      })
    },
    /**
     * 初始化
     */
    init() {
      this.isInit = true
      this.sort = ''
      this.showBannerSkeleton = true
      this.showCateSkeleton = true
      this.showGoodsListSkeleton = true
      this.isLoadingGoodsList = false
      if (this.$refs.filterView) {
        this.$refs.filterView.init()
      }
      this.fetchBannerList()
      this.fetchCateList()
      if (this.isHomePage) {
        // 是首页tab
        this.fetchChoiceGoodsList()
        this.fetchRecommendGoodsList(1)
      } else {
        this.fetchTabGoodsList(1)
      }
    },
    /**
     * 滚动到顶部
     */
    scroll2Pos(topPosition) {
      if (this.scrollVM) {
        this.scrollVM.reflowScroller()
        this.$nextTick(() => {
          this.scrollVM.scrollTo(0, topPosition, false)
        })
      }
    },
    onPullingUp() {
      if (this.isInit) {
        if (this.isHomePage && this.recommendGoodsListData.loadMore) {
          this.fetchRecommendGoodsList(this.recommendGoodsListData.currentPage + 1)
        } else if (!this.isHomePage && this.tabGoodsListData.loadMore) {
          this.fetchTabGoodsList(this.tabGoodsListData.currentPage + 1)
        }
      }
    },
    /**
     * 加载轮播
     */
    fetchBannerList() {
      if (this.$http[this.channel].tabSlideList) {
        this.$http[this.channel]
          .tabSlideList(this.tabId)
          .then(res => {
            this.bannerList = res.data
            this.showBannerSkeleton = false
            this.$nextTick(() => {
              this.scrollVM.reflowScroller()
            })
          })
          .catch(() => {
            this.showBannerSkeleton = false
          })
      } else {
        this.showBannerSkeleton = false
      }
    },

    /**
     * 加载分类列表
     *
     * 总数量少于或等于10,不需分页 (列的索引为: %5 取余) 展示效果如下:
     * 0, 1, 2, 3, 4
     * 5, 6, 7, 8, 9
     *
     * 总数量大于10,需分页(列的索引为: /2 取整) 展示效果如下:
     * 0,2,4,6,8  10,12,14,16,18  20 22 ...
     * 1,3,5,7,9  11,13,15,17,19  21 23 ...
     */
    fetchCateList() {
      if (this.$http[this.channel].tabCateAllList) {
        this.$http[this.channel]
          .tabCateAllList(this.tabId)
          .then(res => {
            let arr = res.data
            let menuList = []
            for (let i = 0; i < arr.length; i++) {
              let column = Math.floor(arr.length <= 10 ? i % 5 : i / 2)
              if (!menuList[column]) {
                menuList[column] = []
              }
              menuList[column].push(arr[i])
            }
            this.tabCateList = menuList
            this.showCateSkeleton = false
            this.$nextTick(() => {
              this.scrollVM.reflowScroller()
            })
          })
          .catch(() => {
            this.showCateSkeleton = false
          })
      } else {
        this.showCateSkeleton = false
      }
    },
    /**
     * 更改排序方式
     */
    handleChangeSort(sort) {
      this.sort = sort
      this.fetchTabGoodsList(1)
    },
    /**
     * 加载好货优选
     */
    fetchChoiceGoodsList() {
      this.$http[this.channel].choiceGoodsList(1, 3).then(res => {
        this.choiceGoodsInfo.cate = res.data.cate
        this.choiceGoodsInfo.data = res.data.goods
        this.$nextTick(() => {
          this.scrollVM.reflowScroller()
        })
      })
    },
    /**
     * 为你推荐商品列表
     */
    fetchRecommendGoodsList(currentPage) {
      if (this.isLoadingGoodsList) return
      this.isLoadingGoodsList = true
      if (currentPage === 1) {
        this.showGoodsListSkeleton = true
      }
      this.$http[this.channel]
        .recommendGoodsList(currentPage, 20)
        .then(res => {
          this.recommendGoodsListData = getPageData(currentPage, this.recommendGoodsListData, res)
          this.scrollVM.finishLoadMore()
          this.showGoodsListSkeleton = false
          this.isLoadingGoodsList = false
          this.$nextTick(() => {
            this.scrollVM.reflowScroller()
          })
        })
        .catch(() => {
          this.showGoodsListSkeleton = false
          this.isLoadingGoodsList = false
        })
    },
    /**
     * tab对应的商品列表
     */
    fetchTabGoodsList(currentPage) {
      if (this.isLoadingGoodsList) return
      this.isLoadingGoodsList = true
      if (currentPage === 1) {
        this.showGoodsListSkeleton = true
      }
      this.$http[this.channel]
        .tabGoodsList(this.tabId, this.sort, currentPage, 20)
        .then(res => {
          this.tabGoodsListData = getPageData(currentPage, this.tabGoodsListData, res)
          this.scrollVM.finishLoadMore()
          this.showGoodsListSkeleton = false
          this.isLoadingGoodsList = false
          this.$nextTick(() => {
            this.scrollVM.reflowScroller()
          })
        })
        .catch(() => {
          this.showGoodsListSkeleton = false
          this.isLoadingGoodsList = false
        })
    },
    /**
     * 点击轮播图
     */
    handleClickBanner(item) {
      switch (item.slideRule.type) {
        case 0: // 商品详情
          this.$router.push({ name: 'productDetail', query: { goodsId: item.slideRule.id } })
          break
        case 1:
        case 2:
        case 3: // 商品列表
          this.$router.push({
            name: 'productList',
            query: {
              channel: this.channel,
              type: 'slide',
              colNum: item.slideRule.type,
              id: item.slideRule.id,
              title: item.slideName,
              bannerImg: item.slideImg,
            },
          })
          break
        case 4: // 淘宝活动页
          this.$router.push({ name: 'taobaoActivity' })
          break
      }
    },
    /**
     * 点击跳转分类对应的商品列表
     */
    handleClickGoCateGoodsList(cateItem) {
      this.$router.push({ name: 'productList', query: { channel: this.channel, type: 'cate', id: cateItem.cateId, title: cateItem.cateName } })
    },
    /**
     * 处理轮播图触摸事件
     */
    handleTouchBanner(e) {
      if (this.bannerList.length > 1) {
        // 阻止滑动事件冒泡
        e.stopPropagation()
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.component-tabPage {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  .banner-list {
    margin: 0 0.3rem;
    margin-bottom: 0.14rem;
    border-radius: 0.08rem;
    .banner-img {
      float: left;
      width: 100%;
      height: 100%;
      border-radius: 0.08rem;
    }
  }
  .cate-wrap {
    // 分类菜单
    position: relative;
    margin: 0 0.3rem;
    background: #fff;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    overflow: hidden;
    .swiper-wrap {
      display: flex;
    }
    .cate-list {
      // 滚动器
      padding: 0.16rem 0 0.4rem 0;
      .cate-column {
        // 滚动item
        display: flex;
        flex-flow: column;
        .cate-item {
          // 分类菜单item
          position: relative;
          display: flex;
          width: 100%;
          flex-direction: column;
          align-items: center;
          margin-top: 0.07rem;
          &:nth-child(2) {
            margin-top: 0.28rem;
          }
          .cate-img {
            display: block;
          }
          .label {
            width: 100%;
            font-size: 0.24rem;
            color: #232321;
            height: 0.36rem;
            line-height: 0.36rem;
            margin-top: 0.2rem;
            text-align: center;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }
      }
    }
    .tabCateSwiper-scrollbar {
      // 滚动条
      position: absolute;
      bottom: 0.16rem;
      left: 50%;
      margin-left: -0.52rem;
      width: 1.04rem;
      height: 0.06rem;
      background: #e2e2e2;
      border-radius: 0.06rem;
    }
  }
  .banner-skeleton {
    // 轮播图的骨架屏
    margin: 0 0.3rem;
    padding: 0.16rem 0 0;
  }
  .tabCate-skeleton {
    // 分类菜单的骨架屏
    margin: 0 0.3rem;
    padding: 0.16rem 0 0;
  }
  .goodsList-skeleton {
    // 商品列表的骨架屏
    padding: 0.4rem 0.3rem;
    .skeleton-item {
      margin-bottom: 0.2rem;
    }
  }
  .goods-list {
    padding: 0 0.2rem 0.4rem;
  }
  .recommendGoods-wrap {
    // 为你推荐
    padding: 0 0.2rem 0.4rem;
  }
  .choiceGoods-wrap {
    // 好货优选
    .choiceGoods-head {
      display: flex;
      align-items: center;
      height: 1rem;
      overflow: hidden;
      padding-left: 0.24rem;
      .icon-live {
        height: 0.4rem;
        margin-right: 0.08rem;
      }
      .more-title {
        font-size: 0.3rem;
        font-weight: bold;
        color: #333;
      }
      .btn-more-goods {
        margin-left: 0.1rem;
        padding: 0.04rem 0.08rem;
        border-radius: 0.02rem;
        background-image: linear-gradient(to right, #ff1a1a, #fd2b6b);
        display: flex;
        align-items: center;
        color: #fff;
        font-size: 0.18rem;
        white-space: nowrap;
        .icon-into {
          margin-left: 0.08rem;
          height: 0.12rem;
          vertical-align: middle;
        }
      }
    }
  }
  .recommendGoods-wrap {
    // 为你推荐
    background: #f7f6f6;
    overflow: hidden;
    .recommendGoods-head {
      height: 1rem;
      display: flex;
      align-items: center;
      justify-content: center;
      .foryou-img {
        width: 80%;
      }
    }
  }
}
</style>
